const Form = {
  ADDING_FORM_ITEM: 'form/add',
  FORM_ITEM_ARCHIVE_ACTION: 'form/archive_action',
  FORM_ITEM_UPDATE_REQUEST: 'form/update_request',
}

export default Form;